/**
 * Captcha del portal ciudadano: prueba de trabajo al estilo ALTCHA, sin servicios externos (no sale ningún dato a
 * terceros) e invisible (sin imágenes ni rompecabezas, así que no deja por fuera a nadie). El API emite un reto
 * firmado: un `salt` y el SHA-256 de `salt + número`; el navegador prueba números hasta dar con él (un segundo o dos)
 * y devuelve la solución en la cabecera `CAPTCHA_HEADER`. Hacerlo una vez cuesta poco; hacerlo miles de veces, mucho.
 * Cada solución sirve una sola vez y vence.
 */
export const CAPTCHA_HEADER = 'x-captcha';
const hex = (buf) => Array.from(new Uint8Array(buf), (b) => b.toString(16).padStart(2, '0')).join('');
const encoder = new TextEncoder();
export async function sha256Hex(text) {
    return hex(await globalThis.crypto.subtle.digest('SHA-256', encoder.encode(text)));
}
/** Busca el número del reto. Null si no está (reto adulterado) o si se cancela. */
export async function solveCaptcha(c, signal) {
    for (let n = 0; n <= c.maxnumber; n++) {
        if (signal?.aborted)
            return null;
        if ((await sha256Hex(c.salt + n)) === c.challenge)
            return { algorithm: c.algorithm, challenge: c.challenge, salt: c.salt, number: n, signature: c.signature };
    }
    return null;
}
/** Valor de la cabecera: la solución en JSON y base64. */
export function encodeCaptcha(s) {
    return btoa(JSON.stringify(s));
}
//# sourceMappingURL=captcha.js.map